import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BarcodeScannerService } from '@evorait/pace-core';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { take } from 'rxjs';

type ChangeCallbackFn = (event: unknown) => void;

@Component({
    selector: 'pace-forms-input-text',
    templateUrl: './input-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputTextComponent),
            multi: true,
        },
    ],
})
export class InputTextComponent implements ControlValueAccessor {
    @Input()
    public id: string;

    @Input()
    public label: string;

    @Input()
    public inputPlaceholder = '';

    @Input()
    public showScanner = false;

    public disabled: boolean;
    public value: string;
    public faBarcode = faBarcode;
    public onChanged: ChangeCallbackFn = () => undefined;
    public onTouched: VoidFunction = () => undefined;
    public constructor(
        private readonly cdr: ChangeDetectorRef,
        private barcodeScannerService: BarcodeScannerService,
    ) {}

    public writeValue(val: string): void {
        if (this.value === val) {
            // markForCheck is needed because the component is being enabled and disabled from the components.
            this.cdr.markForCheck();
            return;
        }
        this.value = val;
        this.cdr.markForCheck();
    }

    public registerOnChange(fn: VoidFunction): void {
        this.onChanged = fn;
    }

    public registerOnTouched(fn: VoidFunction): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public openScanner(): void {
        this.barcodeScannerService
            .scan()
            .pipe(take(1))
            .subscribe((value: { text: string; format: string }) => {
                this.value = value.text;
                this.onChanged(value.text);
            });
    }
}
